/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />

import { getFirstFormAnchorID } from "./functions";

let miStore : MIStore = (window as any).miStore;
const InquiryName = "Inquiry";
const hiddenClassName = "mi-hidden";

let requestQuoteBtnInVariantDiv : HTMLAnchorElement;
let wooCommerceVariantWrapper : JQuery<HTMLElement>; // assign from woocommerce
let priceFromField : HTMLElement;

export interface MIStore{
	assignVariantWrapper : (variantWrapper : JQuery<HTMLElement>) => void;
	determineShowInquiryBtn : (sku:string) => void;
	hideInquiryBtn : () => void; // will be called if click on clear button / set drop down to "Choose an option".
	forSearchPopup : () => void; // Actually for search bar, not tailored for woocommerce.
}

export function handleWooCommerceVariant() {
	// For debug, temp disable the functions by enabling this block:
	// {
	// 	console.log("Debug code, not handle the variant.");
	// 	miStore.assignVariantWrapper = (variantWrapper : JQuery<HTMLElement>) => {};
	// 	miStore.determineShowInquiryBtn = (sku:string) => {};
	// 	miStore.hideInquiryBtn = () => {};
	// 	return;
	// }

	let assignVariantWrapperAndCreateReqestQuoteBtn = (variantWrapper : JQuery<HTMLElement>) => {
		wooCommerceVariantWrapper = variantWrapper;
		if (wooCommerceVariantWrapper && wooCommerceVariantWrapper.length > 0){
			let firstFormId = getFirstFormAnchorID();
			if (firstFormId){
				// Add the Request quote button at the buttom of variantWrapper
				requestQuoteBtnInVariantDiv = document.createElement('a');
				requestQuoteBtnInVariantDiv.classList.add("mi-request-quote-btn-in-variant");
				requestQuoteBtnInVariantDiv.classList.add(hiddenClassName);
				requestQuoteBtnInVariantDiv.innerText = "Request a quote";
				requestQuoteBtnInVariantDiv.href = firstFormId;
				wooCommerceVariantWrapper[0].parentElement.appendChild(requestQuoteBtnInVariantDiv);
			}
		}
	}

	priceFromField = document.querySelector(".mi-product-price-with-from");
	
	// miStore.assignVariantWrapper = assignVariantWrapperAndCreateReqestQuoteBtn;
	// miStore.determineShowInquiryBtn = determineShowInquiryBtn;
	// miStore.hideInquiryBtn = () => {
	// 	showHideInquiryBtn(false);
	// 	showHideFromPrice(true);
	// }

	let variantField = getVariantTextFieldInFirstFormInContent();
	if (variantField){
/////////////
		((window as any).miStore as any).variantField = variantField;
//////////
		variantField.textContent = "";
	}
}

function determineShowInquiryBtn(sku : string){
	// If can determine, then means some options is selected.
	showHideFromPrice(false);

	let isInquiry : boolean;
	if (wooCommerceVariantWrapper && wooCommerceVariantWrapper.length > 0){
		let availability = wooCommerceVariantWrapper.find(".woocommerce-variation-availability");
		let innerText = availability[0].innerText.trim();
		isInquiry = InquiryName == innerText; // Check if the variant is inquiry by comparing the stock status string.
		
		showHideInquiryBtn(isInquiry);
	}
	else{
		isInquiry = false;
		// no variant, so should not display the inquiry button.
		showHideInquiryBtn(false);
	}
}

function showHideInquiryBtn(isInquiry : boolean){
	//console.log("showHideInquiryBtn, isInquiry: " + isInquiry);
	showHideWooCommerceAddToCartCombo(isInquiry);
	if (requestQuoteBtnInVariantDiv){
		if (isInquiry){
			requestQuoteBtnInVariantDiv.classList.remove(hiddenClassName);
		}
		else{
			requestQuoteBtnInVariantDiv.classList.add(hiddenClassName);
		}
	}
	grabTheProductInfoAndSetToForm();
}

function showHideFromPrice(show: boolean) {
	if (!priceFromField)
		return;

	if (show)
		priceFromField.classList.remove("mi-invis");
	else
		priceFromField.classList.add("mi-invis");
}


function showHideWooCommerceAddToCartCombo(isInquiry : boolean) {
	if (wooCommerceVariantWrapper) {
		if (isInquiry) {
			wooCommerceVariantWrapper.hide();
		}
		else {
			wooCommerceVariantWrapper.show();
		}
	}
}

function getFirstFormInContent(){
	let contentWrapper = document.querySelector(".mi-product-content");
	if (!contentWrapper)
		return null;
		
	let wrappers = contentWrapper.querySelectorAll(".mi-main-enquiry");
	if (wrappers.length > 0)
		return wrappers[0] as HTMLElement;
	else
		return null;
}

function getVariantTextFieldInFirstFormInContent(){
	let wrapper = getFirstFormInContent();
	if (wrapper){
		let variationEle = wrapper.querySelector(".variation");
		if (variationEle){
			let textarea = variationEle.querySelector("textarea") as HTMLTextAreaElement;
			if (textarea){
				return textarea;
			}
		}
	}

	return null;
}

function grabTheProductInfoAndSetToForm() {
	// grab the product summary:
	let entrySummary = document.querySelector(".entry-summary");

	let productName = (entrySummary.querySelector(".product_title") as HTMLElement).innerText;

	let variations = (entrySummary.querySelector(".variations") as HTMLElement);

	if (variations){
		let labels = variations.querySelectorAll(".label");
		let selectEles = variations.querySelectorAll("select");

		let lines : string[] = [];
		//lines.push("Url: " + (window as any).mi_curr_url);
		//lines.push("Product/Service: \"" + productName + "\", Attributes:");
		if (labels.length == selectEles.length){
			let len = labels.length;
			for(let i = 0; i < len; i ++){
				let label = (labels[i] as HTMLElement).innerText;
				let selectEle = selectEles[i] as HTMLSelectElement;

				let value = selectEle.value;

				let line = label + ": " + value;
				lines.push(line);
			}
		}
		else{
			console.error("Fail, should not happen.");
		}

		let variantField = getVariantTextFieldInFirstFormInContent();
		if (variantField){
			let combined = lines.join("; ");
			variantField.textContent = combined;
		}
		else{
			console.warn("Fail to find the variation text area");
		}
	}
}

